import i18n from "@/i18n"

const errorInputMsg = {
  'vehicle_id/required': () => i18n.t('fleetTaskInstant.input.error.vehicle.required'),
  'vehicle_id/already-registered': () => i18n.t('fleetTaskInstant.input.error.vehicle.alreadyRegistered'),
  'vehicle_id/vehicleGroupInvalid': () => i18n.t('fleetTaskInstant.input.error.vehicle.vehicleGroupInvalid'),
  'vehicle_id/value-not-found': () => i18n.t('fleetTaskInstant.input.error.vehicle.valueNotFound'),
  'vehicle_id/vehicle status invalid': () => i18n.t('fleetTaskInstant.input.error.vehicle.statusInvalid'),
  'driver_id/required': () => i18n.t('fleetTaskInstant.input.error.vehicle.required'),
  'driver_id/already-registered': () => i18n.t('fleetTaskInstant.input.error.driver.alreadyRegistered'),
  'driver_id/driverUserGroupInvalid': () => i18n.t('fleetTaskInstant.input.error.driver.driverUserGroupInvalid'),
  'driver_id/value-not-found': () => i18n.t('fleetTaskInstant.input.error.driver.valueNotFound'),
  'user_group_id/required': () => i18n.t('fleetTaskInstant.input.error.userGroup.required'),
  'phone_number/is-not-valid-phone-number': () => i18n.t('fleetTaskInstant.input.error.phoneNumber.invalidFormat'),

  'address/required': () => i18n.t('fleetTaskInstant.input.error.address.required'),
  'address/point-overlap': () => i18n.t('fleetTaskInstant.input.error.address.pointOverlap'),
  'address/value-not-found': () => i18n.t('fleetTaskInstant.input.error.address.valueNotFound'),
  'target_time_arrival/required': () => i18n.t('fleetTaskInstant.input.error.targetArrival.required'),
  'target_time_departure/required': () => i18n.t('fleetTaskInstant.input.error.targetDeparture.required'),
}

export default errorInputMsg
